export const LOCATION_DROPDOWN_ID = 'locations-dropdown';
export const SELECT_LOCATION_BTN = 'select-location-btn';

export function getLocationDropdown() {
  return document.getElementById(LOCATION_DROPDOWN_ID);
}

export function getSelectedLocation() {
  const locationDropdown = getLocationDropdown();
  if (!locationDropdown) {
    throw new Error('No locations dropdown in DOM');
  }

  const { options, selectedIndex } = locationDropdown;
  return options[selectedIndex];
}

export function getLocationDropdownSelectedId() {
  const locationDropdown = getLocationDropdown();
  return locationDropdown && locationDropdown.value;
}

export function getLocationDropdownSelectedName() {
  const selectedLocation = getSelectedLocation();
  return selectedLocation && selectedLocation.text;
}
